import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
  as?: 'div' | 'section' | 'li' | 'article' | 'header';
};
export function Reveal({
  children,
  delay = 0,
  y = 24,
  className,
  as = 'div'
}: RevealProps) {
  const MotionTag = motion[as];
  return <MotionTag className={className} initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.8,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-261" data-mp="3gfxl2r0hvchl">
      {children}
    </MotionTag>;
}